import { Chip } from "@mui/material";
import React from "react";
import { getProjectStatusLabel } from "../../../utils/projectStatusUtils";

interface ProjectChipProps {
  status: string;
  size?: "small" | "medium";
}

/**
 * ProjectChip component
 * @param status - Status of the project can be "application", "offer", "active", "invoiced" or "completed
 * @returns - A chip component with the status of the project in different colors
 */
const ProjectChip: React.FC<ProjectChipProps> = ({ status, size }) => {
  switch (status) {
    case "Lead":
      return (
        <Chip
          label={getProjectStatusLabel(status)}
          color="warning"
          size={size ? size : "small"}
          sx={{ minWidth: 75, fontWeight: "bold" }}
        />
      );
    case "Bewerbung":
      return (
        <Chip
          label={getProjectStatusLabel(status)}
          color="success"
          size={size ? size : "small"}
          sx={{ minWidth: 75, fontWeight: "bold" }}
        />
      );
    case "Angebot":
      return (
        <Chip
          label={getProjectStatusLabel(status)}
          color="info"
          size={size ? size : "small"}
          sx={{ minWidth: 75, fontWeight: "bold" }}
        />
      );
    case "Durchführung":
      return (
        <Chip
          label={getProjectStatusLabel(status)}
          color="primary"
          size={size ? size : "small"}
          sx={{ minWidth: 75, fontWeight: "bold" }}
        />
      );
    case "Abrechnung":
      return (
        <Chip
          label={getProjectStatusLabel(status)}
          size={size ? size : "small"}
          sx={{ bgcolor: "#ad3d9b", color: "#fff", minWidth: 75, fontWeight: "bold" }}
        />
      );
    case "Abgeschlossen":
      return (
        <Chip
          label={getProjectStatusLabel(status)}
          color="secondary"
          size={size ? size : "small"}
          sx={{ minWidth: 75, fontWeight: "bold" }}
        />
      );
    case "NichtBesetzt":
      return (
        <Chip
          label={getProjectStatusLabel(status)}
          color="error"
          size={size ? size : "small"}
          sx={{ minWidth: 75, fontWeight: "bold" }}
        />
      );
    case "PitchVerloren":
      return (
        <Chip
          label={getProjectStatusLabel(status)}
          color="error"
          size={size ? size : "small"}
          sx={{ minWidth: 75, fontWeight: "bold" }}
        />
      );
    case "AngebotAbgelehnt":
      return (
        <Chip
          label={getProjectStatusLabel(status)}
          color="error"
          size={size ? size : "small"}
          sx={{ minWidth: 75, fontWeight: "bold" }}
        />
      );
    case "Abgebrochen":
      return (
        <Chip
          label={getProjectStatusLabel(status)}
          color="error"
          size={size ? size : "small"}
          sx={{ minWidth: 75, fontWeight: "bold" }}
        />
      );
    default:
      return (
        <Chip
          label={getProjectStatusLabel(status)}
          color="primary"
          size={size ? size : "small"}
          sx={{ minWidth: 75, fontWeight: "bold" }}
        />
      );
  }
};

export default ProjectChip;
